import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const storageVersion = 'v1.2.0';

if (localStorage.getItem('version') !== storageVersion) {
  localStorage.clear();
  localStorage.setItem('version', storageVersion);
}

if (environment.production) {
  enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], });

bootstrap().catch((err) => console.error(err));
